import React from 'react'
import { NextImage } from '@/components/NextImage'

import classes from '../styles.module.scss'

interface FavoriteTeamIconProps {
  src: string
  alt?: string
}

export const FavoriteTeamIcon: React.FC<FavoriteTeamIconProps> = ({ src, alt }) => (
  <div className={classes.favoriteTeamIcon} data-testid="component-navbar-favorite-team-icon">
    <NextImage src={src} alt={alt || ''} width={40} height={40} />
  </div>
)
